




import { Component, Vue, Prop } from 'vue-property-decorator';
import { OrderHistory } from '@/models/order-history';

@Component
export default class OrderHistoryDescription extends Vue {
    @Prop({ required: true }) public entry: OrderHistory;

    public get description(): string {
        switch (this.entry.name) {
        case 'OrderCreated':
            return `Order created by ${this.entry.generatedBy}`;
        case 'OrderStatusChanged':
            return `Quote status changed to '${this.statusDescription(this.entry.data.status)}'`;
        case 'OrderReceived':
            return `Status changed to 'Received'`;
        case 'OrderDelivered':
            return `Status changed to 'Delivered'`;
        default:
            return this.entry.name;
        }
    }

    private statusDescription(status: number): string {
        switch (status) {
        case 0:
            return `Ordered`;
        case 1:
            return `Received`;
        case 2:
            return `Delivered`;
        default:
            return `Unknown`;
        }
    }
}
